import { Card, Skeleton } from '@/shared/components';

type Props = {
  qty: number;
};

const SkeletonItem = () => (
  <div className="flex gap-[1.6rem] items-center">
    <Skeleton variant="avatar" className="w-[4.4rem]" />
    <div>
      <Skeleton variant="medium" className="w-[8.2rem] mb-[0.8rem]" />
      <Skeleton variant="small" className="w-[5.3rem]" />
    </div>
  </div>
);

const ItemsListSkeleton = ({ qty }: Props) => {
  return (
    <Card className="space-y-[2.4rem] px-[3.2rem] py-[2rem] shadow-none">
      {Array.from({ length: qty }).map((_, index) => (
        <SkeletonItem key={index} />
      ))}
    </Card>
  );
};

export { ItemsListSkeleton };
